<template>
    <nuxt-link 
        :to="$prismic.linkResolver(card)"
        class="review-container"
    >
        <div class="review-header">
            <prismic-image 
                :img="card.data.image"
                :alt="card.data.title"
                w="100"
            />
            <div class="name-and-rating">
                <span class="rater-name">
                    {{ review.rater_name }}
                </span>
                <stars 
                    :rating="review.rating_score"
                    class="rating"
                    size="sm" 
                />
            </div>
        </div>
        <div 
            class="review-text rich-text"
            v-html="$format.comment(review.rating_body)"
        />
        <div class="review-footer">
            <div class="review-date">
                <i class="far fa-calendar" />
                <span class="date">
                    {{ $format.date(review.posted_at) }}
                </span>
            </div>
            <span class="read-review"> 
                {{ $translate('cta_read_review', 'Läs recension') }}
                <i class="fas fa-arrow-right" />
            </span>
        </div>
    </nuxt-link>
</template>

<script>
import Stars from '@/components/Stars.vue';
export default {
    components: {
        Stars
    },
    props: {
        review: {
            type: Object,
            required: true
        }
    },
    computed: {
        card() {
            return this.$store.state.cards[this.review.cardId];
        }
    }
};
</script>
<style lang="scss" scoped>
    .review-container::v-deep {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1rem;
        box-shadow: $bxs;
        @include border-radius(25px);
        @include border(all, 1px);
        &:hover {
            .review-footer .read-review {
                color: $green;
            }
        }

        .review-header {
            display: flex;
            align-items: center;
            gap: 1rem;

            .name-and-rating{
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                .rater-name {
                    display: inline-block;
                    line-height: 1.2;
                    font-weight: bold;
                    &:first-letter {
                        text-transform: uppercase;
                    }
                }
                .rating {
                    width: fit-content;
                    flex-shrink: 0;
                }
            }
        }

        .review-footer {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            justify-content: space-between;
            flex-grow: 1;
            gap: 1rem;
            .review-date {
                .date {
                    font-weight: lighter;
                    font-size: .875em;
                    opacity: .7;
                }
                i {
                    opacity: 1;
                    margin-right: 0.25rem;
                }
            }
            .read-review {
                color: $font;
                i {
                    color: $green;
                    margin-left: 0.5rem;
                }
            }
        }
        .review-text {
            @include border(top, 1px);
            padding-top: 0.5rem;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;

            :first-child {
                margin-top: 0;
            }
        }
    }
</style>